<template lang="pug">

div(:class="isUsersRoute ? '' : 'ui bottom attached segment'")

    .three.fields

        //- Anrede
        dropdown-field(
            label='Anrede'
            optionValue='value'
            optionLabel='label'
            v-bind:options='salutations'
            v-bind:isRequired='true'
            v-model='salutation'
        )
            field-error(v-bind:validation='validation' attribute='salutation')

        //- Vorname
        text-field(label='Vorname' v-model='firstName' v-bind:isRequired='true')
            field-error(v-bind:validation='validation' attribute='firstName')

        //- Nachname
        text-field(label='Nachname' v-model='lastName' v-bind:isRequired='true')
            field-error(v-bind:validation='validation' attribute='lastName')

    .two.fields

        //- Unternehmen
        dropdown-field(
            label='Unternehmen'
            v-bind:options='companyModels'
            v-bind:isDisabled='disableCompany'
            v-bind:isRequired='true'
            v-model='company'
            v-if='!hideCompany'
        )
            field-error(v-bind:validation='validation' attribute='company')

        //- E-Mail
        text-field(label='E-Mail' v-model='email' v-bind:isRequired='true')
            field-error(v-bind:validation='validation' attribute='email')

        //- Telefonnummer
        text-field(label='Telefonnummer' v-model='telephone')
            field-error(v-bind:validation='validation' attribute='telephone')

</template>

<script>
    import * as R from 'ramda'
    import { Validator } from 'simple-vue-validator'
    import DropdownField from '@/components/form/DropdownField.vue'
    import FieldError from '@/components/form/SmartFieldError'
    import TextField from '@/components/form/TextField.vue'

    //noinspection JSUnusedGlobalSymbols,ReservedWordAsName
    export default {
        name: 'person-form-component',

        components: { DropdownField, FieldError, TextField },

        computed: {

            company: {
                get() { return this.value.company },
                set(value) { this.updateValue('company', value) }
            },

            email: {
                get() { return this.value.email || '' },
                set(value) { this.updateValue('email', value) }
            },

            firstName: {
                get() { return this.value.firstName || '' },
                set(value) { this.updateValue('firstName', value) }
            },

            lastName: {
                get() { return this.value.lastName || '' },
                set(value) { this.updateValue('lastName', value) }
            },

            persons() {
                return this.$store.getters['persons/all']
            },

            salutation: {
                get() { return this.value.salutation || '' },
                set(value) { this.updateValue('salutation', value) }
            },

            telephone: {
                get() { return this.value.telephone || '' },
                set(value) { this.updateValue('telephone', value) }
            },

            isUsersRoute() {
                return this.$route && this.$route.path && this.$route.path.startsWith('/users')
            },

        },

        data() {
            return {
                salutations: [
                    { value: 'MRS', label: 'Frau' },
                    { value: 'MR', label: 'Herr' }
                ]
            }
        },

        props: {

            companyModels: {
                type: Array,
                default: () => []
            },

            hideAddress: {
                type: Boolean,
                default: false
            },

            disableCompany: {
                type: Boolean,
                default: false
            },

            hideCompany: {
                type: Boolean,
                default: false
            },

            value: {
                type: Object,
                required: true
            }

        },

        methods: {

            cancel() {
                this.$emit('cancel')
            },

            updateValue(prop, value) {
                this.$emit('input', R.assoc(prop, value, this.value))
            },

            validate() {
                return this.$validate()
            }

        },

        validators: {

            company(value) {
                return Validator.value(R.defaultTo('', value))
                    .custom(() => {
                        if (!this.hideCompany && Validator.isEmpty(value)) {
                            return 'Darf nicht leer sein. Bitte ein Unternehmen auswählen'
                        }
                    })
            },

            email(value) {
                return Validator.value(R.defaultTo('', value))
                    .required('Darf nicht leer sein. Bitte eine E-Mail-Adresse eingeben')
                    .email('Ungültiges Format. Bitte eine gültige E-Mail-Adresse eingeben')
                    .custom(R.composeP(

                        // Pruefen ob Person mit angegbene E-Mail bereits existiert
                        R.ifElse(R.propEq('length', 0),
                            R.always(undefined),
                            R.always('E-Mail-Adresse existiert bereits')
                        ),

                        // Nach exakter E-Mail-Filtern
                        R.filter(R.propEq('email', value)),

                        // Personen mit aktueller Personen ID ausfiltern
                        R.reject(R.propEq('id', this.value.id)),

                        // Personen laden
                        () => this.$store.dispatch('persons/loadAll', { params: { email: value }})
                    ))
            },

            firstName(value) {
                return Validator.value(R.defaultTo('', value))
                    .required('Darf nicht leer sein. Bitte eine gültige Vornamen eingeben')
            },

            lastName(value) {
                return Validator.value(R.defaultTo('', value))
                    .required('Darf nicht leer sein. Bitte eine gültige Nachnamen eingeben')
            },

            salutation(value) {
                return Validator.value(R.defaultTo('', value))
                    .required('Darf nicht leer sein. Bitte eine Anrede auswählen')
            },

            telephone(value) {
                return Validator.value(R.defaultTo('', value))
                    .regex(/^[+\d\s()/-]*$/, 'Ungültiges Format. Bitte gültige Telefonnummer eingeben')
            },

        },

    }

</script>
